import React from 'react';
import Link from 'shared/SlashLink';

// Contextual conversion block for the pipeline pages. `context` tailors the
// headline to a county or housing type (e.g., "San Diego County").
const PipelineCTA = ({ context }) => (
    <div
        className="pipeline_cta my-5 p-4 p-lg-5"
        style={{ background: '#fff', border: '1px solid #ead9cd', borderLeft: '5px solid #B85C38', borderRadius: 16 }}
    >
        <div className="row align-items-center">
            <div className="col-lg-8 mb-3 mb-lg-0">
                <h2 className="h4 mb-2">
                    Building affordable housing{context ? ` in ${context}` : ' in California'}?
                </h2>
                <p className="m-0 text-muted">
                    BUILDLAB designs and coordinates the low-voltage, security, and life-safety scope these projects
                    depend on — Division 27/28 structured cabling, IP surveillance, door access, DAS/ERCCS, and
                    common-area networks — engineered in-house and coordinated across every trade to keep
                    infrastructure costs contained. Get a free budget estimate scoped to your unit count and building type.
                </p>
            </div>
            <div className="col-lg-4 text-lg-end">
                <Link to="/affordable-housing#roi" className="btn btn-primary">
                    <span className="btn_label" data-text="Estimate your project">Estimate your project</span>
                    <span className="btn_icon"><i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i></span>
                </Link>
            </div>
        </div>
    </div>
);

export default PipelineCTA;
